import { env } from '@/config/env';
import { cn } from '@/lib/utils';

export function AppVersion({ className }: { className?: string }) {
    return (
        <p className={cn('text-xs text-gray-500 opacity-50', className)}>
            Elektra App version:
            {' '}
            {env.appVersion}
        </p>
    );
}
